// @flow
import React from 'react'
import './styles.scss'
import { browserCheck } from '@ta-interaktiv/browsercheck'

const isMobile = browserCheck.isMobile

export class SectionTitle extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800
    }
  }

  render() {
    return (
      <div className='section-title'>
        <h3>{this.props.children}</h3>
        <div className='hr-theme-slash-2'>
          <div className='hr-line' />
          <div className='hr-icon'>
            <img
              className={`${this.props.mediaName}-icon`}
              src={`https://interaktiv.tagesanzeiger.ch/static/icons/${this.props.mediaName}.svg`}
              alt=''
            />
          </div>
          <div className='hr-line' />
        </div>
      </div>
    )
  }
}
